import React, { useState } from "react";
import "./ImageSlider.css";

const ImageSlider = ({ images, title, description }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showAfter, setShowAfter] = useState(true);

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
    setShowAfter(true);
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
    setShowAfter(true);
  };

  const toggleBeforeAfter = () => {
    setShowAfter(!showAfter);
  };

  return (
    <div className="slider-container">
      <h2 className="slider-title">{title}</h2>
      <p className="slider-description">{description}</p>

      <div className="slider-wrapper">
        {images.length > 1 && (
          <button className="slider-nav prev" onClick={prevImage}>
            ‹
          </button>
        )}

        <div className="slider-content">
          <div className="image-container">
            <img
              src={
                showAfter
                  ? images[currentImageIndex].after
                  : images[currentImageIndex].before
              }
              alt={`${images[currentImageIndex].title} - ${
                showAfter ? "After" : "Before"
              }`}
              className="slider-image"
            />
            <div className="image-label">{showAfter ? "AFTER" : "BEFORE"}</div>
          </div>

          <div className="slider-controls">
            <button className="before-after-btn" onClick={toggleBeforeAfter}>
              {showAfter ? "Show Before" : "Show After"}
            </button>
          </div>
        </div>

        {images.length > 1 && (
          <button className="slider-nav next" onClick={nextImage}>
            ›
          </button>
        )}
      </div>

      <div className="slider-indicators">
        {images.length > 1 &&
          images.map((_, index) => (
            <button
              key={index}
              className={`indicator ${
                index === currentImageIndex ? "active" : ""
              }`}
              onClick={() => {
                setCurrentImageIndex(index);
                setShowAfter(true);
              }}
            />
          ))}
      </div>
    </div>
  );
};

export default ImageSlider;
